import React from 'react';
// Import Component Styles
import { ProgressWrapper, ProgressBar } from './styles';

export default ({ usedValue }) => (
  <ProgressWrapper>
    <ProgressBar usedValue={usedValue} />
  </ProgressWrapper>
);
